export default __webpack_public_path__ + "static/media/login-bg-50.1a80fe62.jpg";